import { render, staticRenderFns } from "./TenantUsers.vue?vue&type=template&id=34a3b5b0&scoped=true"
import script from "./TenantUsers.vue?vue&type=script&lang=js"
export * from "./TenantUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a3b5b0",
  null
  
)

export default component.exports